import { useTranslation } from "react-i18next";
import { stdObject } from "../../../data/types/stdObject";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import { userTypes } from "../../../data/types/userTypes";
import { objectToArray } from "../../../utils/objectToArray";
import { getChildrenValues } from "../../../utils/getChildrenValues";
import { useMemo, useState } from "react";
import { colors } from "../../../data/colors";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import CircleIcon from "@mui/icons-material/Circle";
import LanguageIcon from "@mui/icons-material/Language";
import IconIntoDiv from "../../../components/IconIntoDiv";
import { useMainContext } from "../../../context/MainContext";
import { openCat } from "../../MainFrame/functions/category/openCat";

export default function CategoriesList({ data = {} }: { data?: stdObject }) {
  const { t } = useTranslation();
  const {
    setWindowValues,
    setModalData,
    setMsg,
    setMsg2,
    closeMsg,
    logoutAction,
  } = useMainContext();
  const [catValues, setCatValues] = useState<stdObject>({
    selected: data.value,
    closed: [],
  });
  const categories = useSelector((state: RootState) => state.data.cat);
  const itemsList: userTypes = useSelector(
    (state: RootState) => state.data.art,
  );

  const itemsListArray = objectToArray("CODART", itemsList);

  const chooseCat = (id: string | boolean, type: string = "selected") => {
    if (id !== "") {
      let tempValue: number | boolean | string | Array<string> =
        type === "closed" ? catValues[type] : id;
      if (
        type === "closed" &&
        Array.isArray(tempValue) &&
        typeof id === "string"
      ) {
        tempValue = tempValue.includes(id)
          ? tempValue.filter((e: string) => e !== id)
          : [...tempValue, id];
      }

      if (data.onChange && type === "selected") {
        data.onChange(id);
      }

      setCatValues({ ...catValues, [type]: tempValue });
    }
  };

  const getQuantity = (id: string | boolean) => {
    let qChildren =
      typeof id === "string" && id !== ""
        ? [...getChildrenValues(id, categories), Number(id)]
        : [];

    const quantity =
      id === ""
        ? itemsListArray.filter((e: stdObject) => e.FAMART === id).length
        : id === true
          ? itemsListArray.filter((e: stdObject) => e.FAMART !== "").length
          : itemsListArray.filter((e: stdObject) =>
              qChildren.includes(Number(e.FAMART)),
            ).length;

    return quantity > 0 ? ` (${quantity})` : "";
  };

  const countQuantity = useMemo(() => getQuantity, [categories]);

  const writeName = (name: string, id: string | boolean) =>
    name + countQuantity(id);

  type TreeNode = {
    name: string;
    children: TreeNode[];
  };

  const getChildren = (id: any): TreeNode[] =>
    categories
      .filter((e: stdObject) => e.PADCAT === id)
      .map((e: stdObject) => {
        return {
          id: e.CODCAT,
          name: writeName(e.NOMCAT, e.CODCAT.toString()),
          web: e.WEBCAT,
          children: getChildren(e.CODCAT + ""),
        };
      });

  const countChildren = useMemo(() => getChildren, [categories]);

  const catArray = [
    {
      id: "0",
      name: writeName(t("p.withoutCategory"), ""),
      children: [],
    },
    { id: "", name: writeName(t("p.all"), true), children: countChildren("") },
  ];

  const WriteChildren = (
    children: Array<stdObject>,
    parentId: false | string,
    marginLeft: number = 20,
  ) => {
    return children.map((e: stdObject, index: number) => (
      <div
        className="catParent"
        key={index}
        style={{
          marginLeft,
          height:
            typeof parentId === "string" && catValues.closed.includes(parentId)
              ? 0
              : "auto",
        }}
      >
        <div className="catTitle noSelect">
          {e.children.length > 0 && e.id !== "" ? (
            <IconIntoDiv
              onClick={() =>
                data.active ? chooseCat(e.id.toString(), "closed") : {}
              }
              Icon={
                catValues.closed.includes(e.id.toString())
                  ? ArrowRightIcon
                  : ArrowDropDownIcon
              }
            />
          ) : (
            <IconIntoDiv
              onClick={() =>
                data.active ? chooseCat(e.id.toString(), "closed") : {}
              }
              Icon={CircleIcon}
              style={{ fontSize: 8, left: 4, top: 6 }}
            />
          )}
          <div
            style={{
              cursor: "pointer",
              fontSize: 14,
              fontWeight:
                e.id.toString() === catValues.selected ? "bolder" : "normal",
              color:
                e.id.toString() === catValues.selected
                  ? colors.red
                  : colors.black,
            }}
            onClick={() => (data.active ? chooseCat(e.id.toString()) : {})}
            onDoubleClick={() =>
              !data.active && e.id > 0
                ? openCat(e.id, e.name, false, {
                    t,
                    categories,
                    setWindowValues,
                    setModalData,
                    setMsg,
                    setMsg2,
                    closeMsg,
                    logoutAction,
                  })
                : {}
            }
          >
            {e.name}
            {e.web ? (
              <LanguageIcon
                style={{
                  position: "absolute",
                  marginLeft: 5,
                  fontSize: 16,
                  color: colors.lightBlue,
                }}
              />
            ) : (
              <></>
            )}
          </div>
        </div>
        {e.children.length > 0 && WriteChildren(e.children, e.id.toString())}
      </div>
    ));
  };

  return <div className="listBox">{WriteChildren(catArray, false, 0)}</div>;
}
